import React from 'react'
import Navbar from '../components/Navbar';

const ComingSoon = () => {
  return (
    <>
      <div className="image-container mt-19">
        <img src="/images/coming-soon.jpg" alt="coming soon" />
      </div>
    </>
  );
}

export default ComingSoon